import { render, staticRenderFns } from "./InitPasswordPopup.vue?vue&type=template&id=28d1f1df&scoped=true&"
import script from "./InitPasswordPopup.vue?vue&type=script&lang=js&"
export * from "./InitPasswordPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d1f1df",
  null
  
)

export default component.exports